import { useCallback, useMemo } from "react";
import { hasPermission, mergeGrantedPermissions } from "utils/granularPermissions";

export const useModulePermissions = (permissions = [], userPermission = [], moduleName) => {
  const grantedPermissions = useMemo(
    () => mergeGrantedPermissions(permissions, userPermission),
    [permissions, userPermission]
  );

  const hasModulePermission = useCallback(
    (...requiredPermissions) => hasPermission(grantedPermissions, ...requiredPermissions),
    [grantedPermissions]
  );

  const canViewField = useCallback(
    (field) => hasModulePermission(`${moduleName}.fields.${field}.view`),
    [hasModulePermission, moduleName]
  );

  return { grantedPermissions, hasModulePermission, canViewField };
};
